import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-multi-range-slider',
  templateUrl: './multi-range-slider.component.html',
})
export class MultiRangeSliderComponent {
  isBrowser: boolean; 
  maxinput = 40;
  mininput = 15;  
  midValue = 30;
  maxlimit = 60;
  minlimit = 0;
  verticalMaxinput = 40;
  verticalMininput = 15;  
  verticalMidValue = 30;
  verticalMaxlimit = 60;
  verticalMinlimit = 0;
  showSliderIntervals = false;
  useCase = 'Horizontal Slider';
  selectedUseCase = 'Horizontal Slider';
  useCases: string[] = [
    'Horizontal Slider',
    'Vertical Slider'
  ];
  paramsSubscription!: Subscription;

  constructor(
    @Inject(PLATFORM_ID) public platformId: Object,
       private route: ActivatedRoute,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.isBrowser = true;
    } else {
      this.isBrowser = false;
    }
       this.paramsSubscription = this.route.queryParams.subscribe(param => {
      if(param['min'] && param['max']) {
        this.mininput = param['min'];
        this.maxinput = param['max'];
      }
    })
  }

  updateValues(event, key) {
    if (key === 'horizontal') {
    this.maxinput = event.max;
    this.mininput = event.min;
    }
    else if (key === 'vertical') {
      this.verticalMaxinput = event.max;
      this.verticalMininput = event.min;
    }
  }
}